import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppUserComponent } from './app-user.component';
import { AuthGuard } from 'src/common/auth-guard';
import { TourRequestedSentComponent } from './tour/property/tour-requested-sent/tour-requested-sent.component';
import { TourComponent } from './tour/tour.component';
import { GuideDashboardModule } from '../../smartmlsp/components/dynamic-guide/guide-dashboard/guide-dashboard.module';

const routes: Routes = [
  {
    path: '',
    component: AppUserComponent, //outlet: 'LoggedUserHeader',
    children: [
      // { path: 'home', redirectTo: '/home', pathMatch: 'full' },
      // { path: 'home', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuard] },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full', // Ensures exact match for redirection
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('../../smartmlsp/components/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'admins',
        loadChildren: () =>
          import('./system-admins/system-admins.module').then(
            (m) => m.SystemAdminsModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'company-offices',
        loadChildren: () =>
          import('./company-offices/company-offices.module').then(
            (m) => m.CompanyOfficesModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'broker',
        loadChildren: () =>
          import('./broker/broker.module').then((m) => m.BrokerModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'agent',
        loadChildren: () =>
          import('./agent/agent.module').then((m) => m.AgentModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'office-manager',
        loadChildren: () =>
          import('./office-manager/office-manager.module').then(
            (m) => m.OfficeManagerModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./user-profile/user-profile.module').then(
            (m) => m.UserProfileModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'contact',
        loadChildren: () =>
          import('./contacts/contacts.module').then((m) => m.ContactsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'add-listing',
        loadChildren: () =>
          import(
            '../../smartmlsp/components/listing/add-listing/add-listing.module'
          ).then((m) => m.AddListingModule),
      },
      {
        // components under /tour
        path: '',
        component: TourComponent,
        children: [
          //{ path: '', loadChildren: () => import('./tour/tour-dashboard/tour-dashboard.module').then(m => m.TourDashboardModule), canActivate: [AuthGuard] },
          {
            path: 'tours',
            loadChildren: () =>
              import('./tour/tour-dashboard/tour-dashboard.module').then(
                (m) => m.TourDashboardModule
              ),
            canActivate: [AuthGuard],
          },
          {
            path: 'schedule-a-tour',
            loadChildren: () =>
              import('./tour/book-tour/book-tour.module').then(
                (m) => m.BookTourModule
              ),
            canActivate: [AuthGuard],
          },
          {
            path: 'my-tours',
            loadChildren: () =>
              import('./tour/my-tours/my-tours.module').then(
                (m) => m.MyToursModule
              ),
            canActivate: [AuthGuard],
          },
          {
            path: 'Feedback-view',
            loadChildren: () =>
              import('./tour/feedback/feedback.module').then(
                (m) => m.FeedbackModule
              ),
            canActivate: [AuthGuard],
          },
          {
            path: 'booktour-view/:tourId',
            component: TourRequestedSentComponent,
          },
          {
            path: 'booktour-view',
            loadChildren: () =>
              import('./tour/property/property.module').then(
                (m) => m.PropertyModule
              ),
            canActivate: [AuthGuard],
          },
        ],
        canActivate: [AuthGuard],
      },
      /*
      {
        path: 'guide',
        loadComponent: () =>
          import(
            '../../smartmlsp/components/dynamic-guide/guide/guide.component'
          ).then((m) => m.GuideComponent),
      },
      */
      {
        path: 'guide', loadChildren: () => import('../../smartmlsp/components/dynamic-guide/guide-dashboard/guide-dashboard.module').then((m) => m.GuideDashboardModule),
      },
      {
        path: 'my-listings',
        loadChildren: () =>
          import(
            '../../smartmlsp/components/my-listings/my-listings.module'
          ).then((m) => m.MyListingsModule),
      },
      {
        path: 'detailed-listing-view',
        loadChildren: () =>
          import(
            '../../smartmlsp/components/detailed-listing-view/detailed-listing-view.module'
          ).then((m) => m.DetailedListingViewModule),
      },
      {
        path: 'guide-admin',
        loadChildren: () =>
          import('../information-posts/information-posts.module').then(
            (m) => m.InformationPostsModule
          ),
        canActivate: [AuthGuard],
      },
      { path: 'search', loadChildren: () => import('./searchlisting/searchlisting.module').then(m => m.SearchlistingModule), canActivate: [AuthGuard] },
      { path: 'saved-search', loadChildren: () => import('./saved-search/saved-search.module').then(m => m.SavedSearchModule), canActivate: [AuthGuard] },

      // { path: 'tour-dashboard', loadChildren: () => import('../tour/tour-dashboard/tour-dashboard.module').then(m => m.TourDashboardModule), canActivate: [AuthGuard] }
    ],
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppUserRoutingModule {}
